<template>
  <div>
    <p class="mb-4">{{ $t('KnowledgeBase.Header') }}</p>

    <div class="vx-row mt-8 match-height">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base"
        v-for="(section, index) in sections"
        :key="index"
      >
        <vx-card>
          <h4 class="mb-4">{{ section.title }}</h4>
          <ul class="bordered-items">
            <li v-for="(item, index) in section.items" :key="index" class="py-2">
              <a :href="`${item.url}?ref=focusokr`" target="_blank">{{ item.title }}</a>
            </li>
          </ul>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sections: [
        {
          title: this.$t('KnowledgeBase.Sections.Articles'),
          items: [
            {
              title: 'Set goals with OKRs | Google',
              url:
                'https://rework.withgoogle.com/guides/set-goals-with-okrs/steps/introduction/'
            },
            {
              title:
                'The Benefits of Using OKRs to Purposefully Focus Your Personal Life | Aaron Aiken',
              url:
                'https://medium.com/@aaronaiken/the-benefits-of-using-okrs-to-purposefully-focus-your-personal-life-47f6d6553512'
            },
            {
              title:
                'How to set your Personal OKRs and stick to them | James McAulay',
              url:
                'https://medium.com/@jamsusmaximus/how-to-set-your-personal-okrs-and-stick-to-them-632acec44084'
            },
            {
              title: 'OKRs | niket - The Fundamentals',
              url: 'https://medium.com/startup-tools/okrs-5afdc298bc28'
            },
            {
              title: 'Don’t Set Resolutions. Set Personal OKRs. | Alex Mitchell',
              url: 'https://blog.usejournal.com/dont-set-resolutions-set-personal-okrs-a374d8754ce9'
            },
            {
              title: 'Personal OKRs, Three Years Later | Christina Wodtke',
              url: 'https://medium.com/@cwodtke/personal-okrs-three-years-later-7616e60574a4'
            }
          ]
        },
        {
          title: this.$t('KnowledgeBase.Sections.Books'),
          items: [
            {
              title: "Google's OKR playbook | Measure What Matters",
              url: 'https://www.whatmatters.com/resources/googles-okr-playbook'
            },
            {
              title:
                'Radical Focus: Achieving Your Most Important Goals with Objectives and Key Results | Christina Wodtke',
              url:
                'https://www.amazon.com/Radical-Focus-Achieving-Important-Objectives-ebook/dp/B01BFKJA0Y'
            },
            {
              title:
                'Measure What Matters: OKRs: The Simple Idea that Drives 10x Growth | John Doerr',
              url:
                'https://www.amazon.com/Measure-What-Matters-Simple-Drives-ebook/dp/B078X4HKS9'
            }
          ]
        },
        {
          title: this.$t('KnowledgeBase.Sections.Videos'),
          items: [
            {
              title:
                'Accomplish Big Goals With Objectives & Key Results | Christina Wodtke',
              url: 'https://www.youtube.com/watch?v=VYma6PmAX_w'
            },
            {
              title:
                'Startup Lab workshop: How Google sets goals: OKRs | Rick Klau',
              url: 'https://www.youtube.com/watch?v=mJB83EZtAjc'
            }
          ]
        }
      ]
    }
  }
}
</script>
